module.exports = __webpack_public_path__ + "img/google_icon.681dbce6.png";